/* eslint-disable arrow-parens */
/* eslint-disable */
import { useState, useCallback, useEffect, Suspense, useContext } from "react";
import { Navbar } from "./components/Navbar";
import {
	AuthContext,
	DependentContextProvider,
	EligibleDependentContextProvider,
	DependentsContext,
	EnrollmentContextProvider,
	GroupContext,
	GroupEnrollmentContextProvider,
	PaycheckContext,
	ThemeContext,
	ThemeContextProvider,
	GroupOwnerContext,
	GroupOwnerContextProvider
} from "./contexts";
import { BrowserRouter, Route, Switch, useHistory, useLocation } from "react-router-dom";
import {
	AddContacts,
	ChangePassword,
	ClaimList,
	Dependents,
	AddDependent,
	EOB,
	Home,
	AddFamilyMemberForm,
	Benefits,
	PreviewHome,
	Profile,
	AllNotifications,
	Enrollment,
	KsopForm,
	VEBEnrollment,
	HealthCard,
	IntercityGLTDForm,
	IntercityPlanAcknowledgement,
	IntercityHealthPlanForm,
	Documents,
	BOPHealthCard,
	BenefitsV2
} from "./components/pages";
import { NavbarPreview } from "./components/navbarPreview";
import { api } from "./utils/api";

import "./App.css";
import "./globalStyles/theme.css";
import "./globalStyles/paperForm.css";
import "./globalStyles/notificationItem.css";
import "./globalStyles/VEBTheme.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import ClaimDetailsPdf from "./components/pages/claim/EOB/claimLines/ClaimDetailsPdf/ClaimDetailsPdf";
import Redirection from "./components/auth/redirection/Redirection";
import { LogoSettings } from "./types/logoSettings.types";
import Dependent from "./components/pages/home/dependents/dependent/Dependent";
import FAQs from "./components/pages/FAQs/FAQs";
import ContactUs from "./components/pages/contactUs/ContactUs";
import { trackPromise } from "react-promise-tracker";
import AuthenticatedRoute from "./components/shared/authenticatedRoute/AuthenticatedRoute";
import MasterEnrollments from "./components/pages/enrollment/MasterEnrollments";
import IntercityHealthCard from "./components/pages/healthCard/IntercityHealthCard/IntercityHealthCard";
import HealthCardAlert from "./components/shared/healthCardNotActive/healthCardAlert/HealthCardAlert";
import { AutoLogout, HealthCardNotActive, RedirectionHealthCard } from "./components/shared";
import PersonalHealthTest from "./components/pages/PersonalHealthTest/PersonalHealthTest";
import ExplanationOfBenefitsV3 from "./components/pages/claim/explanationOfBenefits/ExplanationOfBenefitsV3";
import { TermedEmployeeNavbar } from "./components/terminatedEmployeeNavbar";
import ProgressiveLabHealthCard from "./components/pages/healthCard/ProgressiveLabHealthCard/ProgressiveLabHealthCard";
import Claim_V2_DetailsGrid from "./components/pages/claim_v2/ClaimStatusDetailsGrid_v2";
import ExplanationOfBenefits from "./components/pages/claim_v2/explanationOfBenefits/ExplanationOfBenefits";
import ExplanationOfBenefitsDetails from "./components/pages/claim_v2/explanationOfBenefits/ExplanationOfBenefits";
import ClaimStatus_v2 from "./components/pages/claim_v2/ClaimStatus";
import { member } from "./utils/api/member/member";
import { unstable_batchedUpdates } from "react-dom";
import { PortalLoader } from "./components/shared/loader/portalLoader/PortalLoader";
import { getIOInstance, joinEmployeeRoom } from "./utils/socket/socket";
import { enrollmentNotificationStore } from "./utils/socket/enrollmentNotification";
import { NotificationModal } from "./components/shared/EventsModal/NotificationModal";

// Test Build

const App = (): JSX.Element => {
	const [url, setUrl] = useState(window.location.pathname);
	const { groupOwner, setGroupOwner } = useContext(GroupOwnerContext);
	const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("@jwt_member"));
	const { setMember } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const { setDependents } = useContext(DependentsContext);
	const [logoSettings, setLogoSettings] = useState<LogoSettings | null>(null);
	const { setTheme, theme } = useContext(ThemeContext);
	const [isVerified, setIsVerified] = useState<boolean>(false);
	const hasSeenLoader = sessionStorage.getItem("hasSeenLoader") === "true";
	const isVerifyRoute = location.pathname.includes("verify");
	const [isInitialLoading, setIsInitialLoading] = useState(!hasSeenLoader && !isVerifyRoute);
	// const [isInitialLoading, setIsInitialLoading] = useState(!hasSeenLoader);
	const [isDataReady, setIsDataReady] = useState(false);
	const { setPaycheck } = useContext(PaycheckContext);
	const [terminatedEmployee, setTerminatedEmployee] = useState<boolean>(false);
	const [notification, setNotification] = useState<{
		isOpen: boolean;
		title: string;
		message: string;
	}>({
		isOpen: false,
		title: "",
		message: ""
	});
	const handleEnrollmentEvent = useCallback(
		({ employeeSSNs, planNames }: { employeeSSNs: string[]; planNames?: string[] }) => {
			console.log("[App] 🔔 Global socket event received");

			if (planNames && planNames.length > 0) {
				setNotification({
					isOpen: true,
					title: "Open Enrollment Available!",
					message: `You have ${planNames.length} new plan${planNames.length > 1 ? "s" : ""
						} ready for enrollment. Click to view details and enroll now.`
				});

				enrollmentNotificationStore.setPending(planNames);
			}
		},
		[]
	);
	const handleNotificationDismiss = useCallback(() => {
		setNotification((prev) => ({ ...prev, isOpen: false }));
	}, []);

	const handleNotificationNavigate = useCallback(() => {
		setNotification((prev) => ({ ...prev, isOpen: false }));
		history.push("/VEB/enrollment");
	}, [history]);
	const fetchInitData = async () => {
		const jwt = localStorage.getItem("@jwt_member");
		if (!jwt || jwt === "null") return;

		try {
			const groupOwnerToken = localStorage.getItem("@jwt_group_owner");
			// console.log("INIT DATA====> 333", groupOwnerToken);
			const memberPortalInitData: any =
				localStorage.getItem("@role") === "DEPENDENT"
					? await trackPromise(api.pages.getDependentPortalInitData())
					: await trackPromise(api.pages.getMemberPortalInitData(groupOwnerToken));
			//for
			localStorage.setItem("@member_data", JSON.stringify(memberPortalInitData.member));
			if (memberPortalInitData.member?.SSN) {
				joinEmployeeRoom(memberPortalInitData.member.SSN);
				console.log("[App] Joined socket room:", memberPortalInitData.member.SSN);
			}
			unstable_batchedUpdates(() => {
				if (memberPortalInitData.member.employee_status === "RELIEVED") {
					setTerminatedEmployee(true);
				}
				setMember({ ...memberPortalInitData.member });
				if (memberPortalInitData.paycheck) setPaycheck({ ...memberPortalInitData.paycheck });
				if (memberPortalInitData.groupOwner) setGroupOwner({ ...memberPortalInitData.groupOwner });
				if (memberPortalInitData.dependents) setDependents([...memberPortalInitData.dependents]);
				setTheme(
					memberPortalInitData.theme ?? { ...theme, group_number: memberPortalInitData.member.group_number }
				);
				// console.log("INIT DATA====>", memberPortalInitData);
				// console.log("INIT DATA====> 2222 ", memberPortalInitData.logoSettings);
				setLogoSettings({ ...memberPortalInitData.logoSettings });
				setIsDataReady(true);
			});
		} catch (error) {
			console.error("Failed to fetch init data:", error);
			setIsDataReady(true);
		}
	};

	useEffect(() => {
		const jwt = localStorage.getItem("@jwt_member");
		if (!jwt || jwt === "null") return;

		let socket = getIOInstance();

		if (socket) {
			socket.on("specificEnrollmentEventVEB", handleEnrollmentEvent);
			console.log("[App] 👂 Socket listener registered");
			return () => {
				socket.off("specificEnrollmentEventVEB", handleEnrollmentEvent);
			};
		}

		// Socket not ready yet — retry until it is
		const interval = setInterval(() => {
			socket = getIOInstance();
			if (socket) {
				clearInterval(interval);
				socket.on("specificEnrollmentEventVEB", handleEnrollmentEvent);
				console.log("[App] 👂 Socket listener registered (after retry)");
			}
		}, 300);

		return () => clearInterval(interval);
	}, [handleEnrollmentEvent]);

	// useEffect(() => {
	// 	const jwt = localStorage.getItem("@jwt_member");
	// 	if (!jwt || jwt === "null") return;

	// 	// Join room as soon as member SSN is available
	// 	const memberData = localStorage.getItem("@member_data");
	// 	if (memberData) {
	// 		try {
	// 			const parsed = JSON.parse(memberData);
	// 			if (parsed?.SSN) {
	// 				joinEmployeeRoom(parsed.SSN);
	// 				console.log("[App] 🔌 Joined socket room:", parsed.SSN);
	// 			}
	// 		} catch (e) {
	// 			console.error("[App] Failed to join socket room:", e);
	// 		}
	// 	}
	// }, []);

	//before
	// useEffect(() => {
	// 	if (location.pathname.includes("verify")) return;
	// 	fetchInitData();
	// }, []);

	//after
	useEffect(() => {
		const initialize = async () => {
			// wait until verify flow stores token
			if (location.pathname.includes("verify")) return;

			// const groupOwnerToken = localStorage.getItem("@jwt_group_owner");

			// // prevent early execution
			// if (!groupOwnerToken) {
			// 	console.log("Waiting for group owner token...");
			// 	return;
			// }

			await fetchInitData();
		};

		initialize();
	}, [location.pathname]);

	// useEffect(() => {
	// 	setUrl(window.location.pathname);
	// }, [window.location.pathname]);
	useEffect(() => {
		console.log("first", location.pathname);
		setUrl(location.pathname);
	}, [location.pathname]);

	const handleLoadingComplete = useCallback(() => {
		sessionStorage.setItem("hasSeenLoader", "true");
		setIsInitialLoading(false);
	}, []);

	// if (isInitialLoading) {
	// 	return <PortalLoader onLoadingComplete={handleLoadingComplete} duration={10000} />;
	// }

	if (isInitialLoading && !location.pathname.includes("verify")) {
		return <PortalLoader onLoadingComplete={handleLoadingComplete} duration={10000} />;
	}
	// console.log(location.pathname, "main app running", history.location.pathname, "test", window.location.pathname);

	return (
		<>
			<Suspense fallback={<div />}>
				<div className="App">
					{/* <BrowserRouter> */}
					<Suspense fallback={<div />}>
						{isDataReady &&
							(!terminatedEmployee ? (
								url.includes("/preview") ? (
									<NavbarPreview />
								) : member ? (
									<Navbar logoSettings={logoSettings} groupOwner={groupOwner} />
								) : null
							) : (
								<TermedEmployeeNavbar logoSettings={logoSettings} />
							))}
					</Suspense>
					{/* <AutoLogout /> */}
					<Switch>
						<Route path="/verify" exact component={Redirection} />
						<Suspense fallback={<div />}>
							<AuthenticatedRoute
								path="/"
								exact
								Component={Home}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/home/add-family-member"
								exact
								Component={AddFamilyMemberForm}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/test-claim-grid"
								exact
								Component={ClaimDetailsPdf}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/change-password"
								exact
								Component={ChangePassword}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/preview"
								exact
								Component={PreviewHome}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/preview"
								exact
								Component={PreviewHome}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/benefits"
								exact
								Component={BenefitsV2}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/documents"
								exact
								Component={Documents}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/personal-health-test"
								exact
								Component={PersonalHealthTest}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<DependentContextProvider>
								<AuthenticatedRoute
									path="/dependent"
									exact
									Component={Dependent}
									isAuth={localStorage.getItem("@jwt_member")}
								/>
								<AuthenticatedRoute
									path="/claims"
									exact
									// Component={ClaimList}
									component={ClaimStatus_v2}
									isAuth={localStorage.getItem("@jwt_member")}
								/>
								<AuthenticatedRoute
									path="/claims_v2"
									exact
									Component={ClaimStatus_v2}
									isAuth={localStorage.getItem("@jwt_member")}
								/>

								<AuthenticatedRoute
									path="/claim_v2-status/EOB"
									exact
									Component={ExplanationOfBenefits}
									isAuth={localStorage.getItem("@jwt_member")}
								/>

								{groupOwner?.role === "EMPLOYER" &&
									(groupOwner.type === "ENROLLER ADMIN" || groupOwner.type === "AGENT") ? null : (
									<AuthenticatedRoute
										path="/claim/EOB"
										exact
										Component={ExplanationOfBenefitsV3}
										isAuth={localStorage.getItem("@jwt_member")}
									/>
								)}
								<AuthenticatedRoute
									path="/dependent/claim/EOB"
									exact
									Component={EOB}
									isAuth={localStorage.getItem("@jwt_member")}
								/>
							</DependentContextProvider>
							<AuthenticatedRoute
								path="/profile"
								exact
								Component={Profile}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/preview"
								exact
								Component={PreviewHome}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/profile/add-contact"
								exact
								Component={AddContacts}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/dependents"
								exact
								Component={Dependents}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/dependents/add-dependent"
								exact
								Component={AddDependent}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/dependents/view-dependent"
								exact
								Component={AddDependent}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/health-card"
								exact
								Component={RedirectionHealthCard}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/clinic-card"
								exact
								Component={RedirectionHealthCard}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/ici-health-card"
								exact
								Component={IntercityHealthCard}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/bop-health-card"
								exact
								Component={RedirectionHealthCard}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/progressive-labs-health-card"
								exact
								Component={RedirectionHealthCard}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/test-group-health-card"
								exact
								Component={RedirectionHealthCard}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							{/* ------------------------------------- (WORK IN PROGRESS) ---------------------------------------- */}
							<AuthenticatedRoute
								path="/ici-health-form"
								exact
								Component={IntercityHealthPlanForm}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/health-card-not-active"
								exact
								Component={HealthCardNotActive}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/GLTD-ici-form"
								exact
								Component={IntercityGLTDForm}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/ici-acknowledge"
								exact
								Component={IntercityPlanAcknowledgement}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							{/* ------------------------------------- (WORK IN PROGRESS) ---------------------------------------- */}
							<GroupEnrollmentContextProvider>
								{/* CommonForm is mounted here too (core plans with same_as_veb_structure)
								    and reads EnrollmentContext, so this route needs the same provider
								    nesting as /VEB/enrollment. */}
							<EligibleDependentContextProvider>
								<EnrollmentContextProvider>
									
									<AuthenticatedRoute
										path="/enrollment"
										exact
										Component={MasterEnrollments}
										isAuth={localStorage.getItem("@jwt_member")}
									/>
									
								</EnrollmentContextProvider>
								<AuthenticatedRoute
									path="/test-group-enrollment"
									exact
									Component={MasterEnrollments}
									isAuth={localStorage.getItem("@jwt_member")}
								/>
								<AuthenticatedRoute
									path="/progressive-labs-enrollment"
									exact
									Component={MasterEnrollments}
									isAuth={localStorage.getItem("@jwt_member")}
								/>
								<AuthenticatedRoute
									path="/bop-enrollment"
									exact
									Component={MasterEnrollments}
									isAuth={localStorage.getItem("@jwt_member")}
								/>
							</EligibleDependentContextProvider>
							</GroupEnrollmentContextProvider>
							<AuthenticatedRoute
								path="/FAQ"
								exact
								Component={FAQs}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/contact-us"
								exact
								Component={ContactUs}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<AuthenticatedRoute
								path="/all-notifications"
								exact
								Component={AllNotifications}
								isAuth={localStorage.getItem("@jwt_member")}
							/>
							<EnrollmentContextProvider>
								<EligibleDependentContextProvider>
									<AuthenticatedRoute
										path="/VEB/enrollment"
										exact
										Component={VEBEnrollment}
										isAuth={localStorage.getItem("@jwt_member")}
									/>
								</EligibleDependentContextProvider>
							</EnrollmentContextProvider>
						</Suspense>
					</Switch>
					{/* </BrowserRouter> */}
				</div>
			</Suspense>
			<NotificationModal
				isOpen={notification.isOpen}
				onClose={handleNotificationDismiss} // X button — just closes
				onNavigate={handleNotificationNavigate} // card click — navigates
				title={notification.title}
				message={notification.message}
				type="success"
				duration={20000}
				position="bottom-right"
			/>
		</>
	);
};

export default App;
